export const LOAD_CALENDAR = "load_calendar";
export const LOAD_CALENDAR_SUCCESSFUL = "load_calendar_successful";
export const LOAD_CALENDAR_ERROR = "load_calendar_error";
